/*
  Bundle cart behaviour: a bundle is one parent line plus zero or more add-on
  lines that share `_bundle_id`. Removing the parent removes the whole group.
*/
(function () {
  'use strict';
  if (window.__ucBundleCart) return;
  window.__ucBundleCart = true;

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer.cus-cart-drawer') || document.querySelector('cart-drawer');
    var jobs = [];
    jobs.push(fetch('/cart?section_id=cus-cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.drawer__inner.cus-cart-drawer__inner') || doc.querySelector('.drawer__inner');
      var current = drawer && (drawer.querySelector('.drawer__inner.cus-cart-drawer__inner') || drawer.querySelector('.drawer__inner'));
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }));
    jobs.push(fetch('/?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (fresh && bubble) bubble.innerHTML = fresh.innerHTML;
    }));
    return Promise.all(jobs);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-remove]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var keys = (btn.getAttribute('data-bundle-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    btn.disabled = true;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('update failed');
      return r.json();
    }).then(function (cart) {
      var inDrawer = !!btn.closest('cart-drawer');
      if (inDrawer) {
        return refreshDrawer().then(function () {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-cart', cartData: cart }); } catch (err) { /* noop */ }
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && cart.item_count === 0) drawer.classList.add('is-empty');
        });
      }
      window.location.reload();
    }).catch(function () {
      btn.disabled = false;
      window.location.reload();
    });
  }, true);
})();
